import { useQuery } from 'react-query';
import { createApiQueryOptions } from './createApiQueryOptions';
import { toHookName, getApiUrlComponents } from '../../apis-infra';
import { useApisClientContext, useQueryOptionsContext } from '../Providers';
import React from 'react';
import { getSharedQueryClient } from './queryClientInstance';
import { mergeQueryOptions } from './internal';
export const createApiHook = _ref => {
  let {
    methodConfig
  } = _ref;
  const queryOptionsBuilder = createApiQueryOptions({
    methodConfig
  });
  return (request, enabled, options) => {
    if (methodConfig.isMutating) {
      console.debug("%cYou are calling " + getApiUrlComponents(methodConfig) + " with a react-hook (use" + methodConfig.name + ") which is configured 'isMutating: true', mutation method should be called as query function", 'color: red; font-size: larger');
    }
    const {
      queryOptions: contextOptions
    } = useQueryOptionsContext();
    const {
      httpClient
    } = useApisClientContext();
    const queryClient = getSharedQueryClient();
    const {
      cancelOnUnmount,
      ignoreQueryContext,
      ...optionsForQuery
    } = options != null ? options : {};
    const queryOptions = React.useMemo(() => queryOptionsBuilder({
      httpClient,
      request,
      options: mergeQueryOptions(ignoreQueryContext ? {} : contextOptions, optionsForQuery)
    }), [httpClient, request, options, contextOptions]);
    React.useEffect(() => {
      return () => {
        Boolean(cancelOnUnmount) && queryClient.cancelQueries(queryOptions.queryKey);
      };
    }, []);
    return useQuery({
      enabled,
      ...queryOptions
    });
  };
};
export const createApiHooks = _ref2 => {
  let {
    apiConfig
  } = _ref2;
  return Object.keys(apiConfig).reduce((acc, methodName) => {
    const methodConfig = apiConfig[methodName];
    return {
      ...acc,
      [toHookName(methodName)]: createApiHook({
        methodConfig
      })
    };
  }, {});
};
//# sourceMappingURL=createApiHook.js.map